import { PageNotFound } from '@crehana/compass.ui/page-not-found';

const WhatsappTemplatesCreateNotFound = () => {
  return <PageNotFound />;
};

export default WhatsappTemplatesCreateNotFound;
